/**
 * GET `admin/clinic-applications` — заявки клиник с лендинга: пагинация,
 * фильтр по статусу, счётчики для чипов и бейджа меню. Gateway говорит
 * camelCase — конверсию кейсов глушим. Без BE — мок.
 */

import {apiEnabled, http} from '@services/utils';

import {buildApplicationsPage} from '../mocks';
import {toApplicationItem} from '../toApplicationItem';
import type {ApplicationItem, ApplicationsPage, GetApplicationsRequest} from '../types';

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

const asNum = (v: unknown, fallback: number): number =>
  typeof v === 'number' && Number.isFinite(v) ? v : fallback;

export const getApplications = async (req: GetApplicationsRequest): Promise<ApplicationsPage> => {
  if (!apiEnabled) {
    await sleep(260);
    return buildApplicationsPage(req);
  }

  const raw = await http<Record<string, unknown>>('admin/clinic-applications', {
    params: {
      ...(req.status !== undefined && {status: req.status}),
      ...(req.phoneVerified !== undefined && {phoneVerified: String(req.phoneVerified)}),
      page: String(req.page ?? 1),
      pageSize: String(req.pageSize ?? 25),
    },
    skipCaseConversion: true,
  });

  const counts =
    typeof raw.statusCounts === 'object' && raw.statusCounts !== null
      ? (raw.statusCounts as Record<string, unknown>)
      : {};
  return {
    list: (Array.isArray(raw.list) ? raw.list : [])
      .map(toApplicationItem)
      .filter((a): a is ApplicationItem => a !== null),
    totalCount: asNum(raw.totalCount, 0),
    currentPage: asNum(raw.currentPage, req.page ?? 1),
    pageSize: asNum(raw.pageSize, req.pageSize ?? 25),
    statusCounts: {
      pending: asNum(counts.pending, 0),
      reviewed: asNum(counts.reviewed, 0),
      rejected: asNum(counts.rejected, 0),
    },
  };
};
